module.exports = __webpack_public_path__ + "img/CY110020.9afa9a8b.png";